const getValueByPropertyPath = (propertyPath, data) =>
  propertyPath ? propertyPath.split('.').reduce((acc, key) => acc?.[key], data) : data;

export default getValueByPropertyPath;
